import { render, staticRenderFns } from "./domesticHelperForm.vue?vue&type=template&id=c33f8b4a&scoped=true&"
import script from "./domesticHelperForm.vue?vue&type=script&lang=js&"
export * from "./domesticHelperForm.vue?vue&type=script&lang=js&"
import style0 from "./domesticHelperForm.vue?vue&type=style&index=0&id=c33f8b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33f8b4a",
  null
  
)

export default component.exports